// extracted by mini-css-extract-plugin
export var menuIcon = "_rc-0";
export var menuIconInline = "_rc-1";